export default __webpack_public_path__ + "302b0a2f5341987d23eec7ae0ef1654a.svg";